import * as vuex from 'vuex-class';
import { IEditorContentState } from '@/editor/editor-block/store/editor-content.types';

export const namespace = 'editorContent';

export const editorContentNamespace = 'editor/editorContent';

export const EditorContent = vuex.namespace(editorContentNamespace);

export enum EEditorContentAction {
  CreateRow = 'createRow',
  SplitTextCreateRow = 'splitTextCreateRow',
  DeleteRow = 'deleteRow',
  DeleteNode = 'deleteNode',
  MoveRow = 'moveRow',
  UpdateNode = 'updateNode',
  MoveNodes = 'moveNodes',
  SetBlock = 'setBlock',
  ResetBlocks = 'resetBlocks',
  RemoveBlock = 'removeBlock',
  UpdateDocumentPage = 'updateDocumentPage',
  RevertDocumentPage = 'revertDocumentPage',
  UpdateCells = 'updateCells',
  MoveCell = 'moveCell',
  MoveCellFailed = 'moveCellFailed',
  ContentUpdateFailed = 'contentUpdateFailed',
  ContentUpdateSuccess = 'contentUpdateSuccess',
  UpdateCustomTagEverywhere = 'updateCustomTagEverywhere',
  UpdateRow = 'updateRow',
}

export enum EEditorContentMutation {
  ReplaceBlock = 'replaceBlock',
  CreateNode = 'createNode',
  UpdateNode = 'updateNode',
  MoveNodes = 'moveNodes',
  DeleteNode = 'deleteNode',
  SetBlock = 'setBlock',
  ResetBlocks = 'resetBlocks',
  RemoveBlock = 'removeBlock',
  CreateRow = 'createRow',
  DeleteRow = 'deleteRow',
  MoveRow = 'moveRow',
  UpdateCells = 'updateCells',
  MoveCell = 'moveCell',
  UpdateCustomTagEverywhere = 'updateCustomTagEverywhere',
  UpdateRow = 'updateRow',
}

export enum EEditorContentGetter {
  AllEditorFields = 'allEditorFields',
  AllUniqueCustomTags = 'allUniqueCustomTags',
  BlockById = 'blockById',
}

export const state: IEditorContentState = {
  blocks: [],
};
